import { AutocompleteField } from "@models/autocompleteField";
import { DataFields } from "@utils/DataField";

export class SituationDataFields extends DataFields {

    availability: AutocompleteField;
    experience: AutocompleteField;
    isHandicaped: boolean;
    isCurrentlyEmployed: boolean;
    situationStatus : AutocompleteField;
    currentJob: AutocompleteField;
    qualificationLevel: AutocompleteField;
    sectors: AutocompleteField[];
    salary: AutocompleteField;
    errorMessage = "Oups, le formulaire est incomplet.";

    _errorDataFieldMap = new Map<string, string>([
        ["availability", "Merci de compléter votre disponibilité actuelle."],
        ["experience", "Merci de compléter votre niveau d'expérience actuel."],
        ["isHandicaped", "Merci d'indiquer si vous êtes reconnu travailleur handicapé."],
        ["isCurrentlyEmployed", "Merci d'indiquer si vous êtes actuellement en poste ou sans emploi."],
        ["situationStatus", "Merci de compléter votre situation actuelle."],
        ["qualificationLevel", "Merci de compléter votre niveau de qualification actuel."],
        ["sectors", "Merci de compléter votre secteur d'activité actuel."],
        ["salary", "Merci de compléter votre niveau de salaire."]
    ]);

    toJson() {
        return {
            "availability" : this.availability,
            "experience": this.experience,
            "isHandicaped": this.isHandicaped,
            "isCurrentlyEmployed": this.isCurrentlyEmployed,
            "situationStatus": this.situationStatus,
            "currentJob": this.currentJob,
            "qualificationLevel": this.qualificationLevel,
            "sectors": this.sectors,
            "salary": this.salary
        }
    }
    toArray() {
        return [
            this._toValidity("currentJob", this.currentJob && this.currentJob.isValid(), false),
            this._toValidity("isCurrentlyEmployed", this.isCurrentlyEmployed !== null),
            this._toValidity("situationStatus", this.situationStatus && this.situationStatus.isValid()),
            this._toValidity("availability", this.availability && this.availability.isValid()),
            this._toValidity("experience", this.experience && this.experience.isValid()),
            this._toValidity("qualificationLevel", this.qualificationLevel && this.qualificationLevel.isValid()),
            this._toValidity("sectors", this.sectors.length > 0),
            this._toValidity("salary", this.salary && this.salary.isValid()),
            this._toValidity("isHandicaped", this.isHandicaped !== null)
        ]
    }
}